/*
 * <shelf-rail>: wires the prev/next buttons in a product shelf header to its
 * horizontally scrolling list. Buttons disable themselves at either end.
 */
if (!customElements.get('shelf-rail')) {
  customElements.define(
    'shelf-rail',
    class ShelfRail extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.shelf__rail');
        const shelf = this.closest('.shelf');
        if (!this.list || !shelf) return;

        this.prev = shelf.querySelector('[data-shelf-prev]');
        this.next = shelf.querySelector('[data-shelf-next]');
        this.prev?.addEventListener('click', () => this.page(-1));
        this.next?.addEventListener('click', () => this.page(1));

        const slides = this.list.children;
        if (!slides.length) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.target === slides[0] && this.prev) this.prev.disabled = entry.isIntersecting;
              if (entry.target === slides[slides.length - 1] && this.next) this.next.disabled = entry.isIntersecting;
            }
          },
          { root: this.list, threshold: 0.9 }
        );
        this.observer.observe(slides[0]);
        this.observer.observe(slides[slides.length - 1]);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      page(direction) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.list.scrollBy({
          left: direction * this.list.clientWidth * 0.9,
          behavior: reduce ? 'auto' : 'smooth',
        });
      }
    }
  );
}
